const atualizarCondicoes = (state, condicoes) => {
    state.condicoes = condicoes;
}

const atualizarCondicao = (state, condicao) => {
    state.condicao = condicao;
}

export default {
    atualizarCondicoes,
    atualizarCondicao
}
